import { useTranslation } from "react-i18next";

import Layout from "@components/layout/Layout";
import CreateSubscriberWorkflow from "@components/form/subscriber/create/CreateSubscriberWorkflow";

const SubscriberCreate = () => {
  const { t } = useTranslation();

  return (
    <Layout
      permissions={["CreateSubscribers"]}
      breadcrumb={[
        {
          label: t("dashboard.dashboard"),
          href: "/polestar",
        },
        {
          label: t("common.subscribers"),
          href: "/polestar/subscribers",
        },
        {
          label: t("subscriber.add_subscriber"),
        },
      ]}
      title={t("subscriber.add_subscriber")}
    >
      <CreateSubscriberWorkflow />
    </Layout>
  );
};

export default SubscriberCreate;
